module.exports = __webpack_public_path__ + "static/media/Allissue.e28843ce.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/Allissue.PNG
// module id = 1531
// module chunks = 1